export default __webpack_public_path__ + "static/media/trending_tokens.d7f5a4aa.svg";